export default "__VITE_ASSET__ISBttjUc__"